var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2305 4.71822C11.7059 3.76059 13.0759 3.76059 13.5514 4.71822L15.4422 8.52688L19.672 9.14161C20.7299 9.29535 21.1612 10.5953 20.3875 11.3446L17.3298 14.3058L18.0513 18.4883C18.2344 19.5499 17.117 20.3433 16.1738 19.8501L12.3909 17.8721L8.60804 19.8501C7.66481 20.3433 6.54744 19.5499 6.73057 18.4883L7.45204 14.3058L4.39437 11.3446C3.62067 10.5953 4.05188 9.29535 5.10979 9.14161L9.33967 8.52688L11.2305 4.71822Z",
    fill: "#2E2E38"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.57a420353333de39d4a6a09a448d7ea3.svg";
export { ForwardRef as ReactComponent };